module.exports = __webpack_public_path__ + "img/Weapon_212.e29e5714.png";